module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.rows), function(row, rowIndex) {
    return _c('div', {
      key: row.id,
      class: [_vm.rowsLength === 1 ? 'col-xs-12' : 'col-sm-6']
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box-body"
    }, [_vm._l((_vm.question.fields), function(field, fieldIndex) {
      return _c(_vm.getFieldComponent(field), {
        key: ("field-" + (row.id) + "-" + (field.uuid)),
        tag: "component",
        attrs: {
          "field": field,
          "fieldAnswer": _vm.getFieldAnswer(rowIndex, field),
          "isDisabled": _vm.disabledAttribute
        },
        on: {
          "fieldUpdated": _vm.onFieldUpdated
        }
      })
    }), _vm._v(" "), (!_vm.disabledAttribute) ? _c('button', {
      staticClass: "btn btn-sm btn-default center-block pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRow(rowIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })]) : _vm._e()], 2)])])
  }), 0), _vm._v(" "), (!_vm.disabledAttribute) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default center-block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRow.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490805f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/CollectionQuestion.vue
// module id = 720
// module chunks = 1